<template>
  <q-select outlined :modelValue="modelValue" :label="label" @update:modelValue="$emit('update:modelValue', $event)"
    use-input hide-selected fill-input input-debounce="0" :options="options">
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          No results
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:error>
      <span v-for="err in errors" :key="err">{{ err }}</span>
    </template>
  </q-select>
</template>

<script setup>
defineProps({
  modelValue: [String, Number],
  errors: [String, Array],
  label: [String],
  options: [Array]
});
defineEmits(['update:modelValue']);
</script>
